export default __webpack_public_path__ + "static/media/IMG_6317.9ae6c20d.jpg";